<section>
  <div class="filter-field" *ngIf="queryElementsConfig()?.gender?.visible">
    <div class="selector-label">Género</div>
    <app-selector [activeColor]="accentColorInHex()" [label]="'Género'" [placeholder]="'Selecciona un género'"
      [options]="genderOptions" [(value)]="selectedGender" (valueChange)="updateFilters()"
      [isOpen]="queryElementsConfig()?.gender?.isOpen" (isOpenChange)="onQueryElementsOpen('gender', $event)">
    </app-selector>
  </div>
  <div class="filter-field" *ngIf="queryElementsConfig()?.category?.visible">
    <div class="selector-label">Categoría</div>
    <app-selector [activeColor]="accentColorInHex()" [label]="'Categoria'" [placeholder]="'Selecciona una categoria'"
      [options]="categoryOptions" [(value)]="selectedCategory" (valueChange)="updateFilters()"
      [isOpen]="queryElementsConfig()?.category?.isOpen"
      (isOpenChange)="onQueryElementsOpen('category', $event)"></app-selector>
    <div>
      <ng-content select="[app-video-category-selector-extra]"></ng-content>
    </div>
  </div>
  <div class="filter-field" *ngIf="queryElementsConfig()?.competition?.visible">
    <div class="selector-label">Competición</div>
    <app-selector [activeColor]="accentColorInHex()" [label]="'Competición'"
      [placeholder]="'Selecciona una competición'" [options]="competitionOptions" [(value)]="selectedCompetition"
      (valueChange)="updateFilters()" [isOpen]="queryElementsConfig()?.competition?.isOpen"
      (isOpenChange)="onQueryElementsOpen('competition', $event)"></app-selector>
    <div>
      <ng-content select="[app-video-competition-selector-extra]"></ng-content>
    </div>
  </div>
  <div class="filter-field" *ngIf="queryElementsConfig()?.dateStart?.visible">
    <label for="dateStart"> Fecha de subida (Desde) </label>
    <input type="date" id="dateStart" [(ngModel)]="dateStart" (ngModelChange)="updateFilters()" name="dateStart" />
  </div>
  <div class="filter-field" *ngIf="queryElementsConfig()?.dateEnd?.visible">
    <label for="dateEnd"> Fecha de subida (Hasta) </label>
    <input type="date" id="dateEnd" [(ngModel)]="dateEnd" (ngModelChange)="updateFilters()" name="dateEnd" />
  </div>
</section>